// Single source of truth for the "can this user reach this nav item / tab?" question.
// Used for styling, never for filtering — a denied item is shown locked, not hidden.
const NO_PERMISSION_MESSAGE = "You don't have permission to access this"

// True if the user holds at least one of the given codes. Fails closed: an empty/missing
// hasPermissions (loading, or genuinely never fetched) is NOT treated as "holds nothing" -
// it's treated as "unknown", which for a non-empty code list resolves to false.
const isAnyPermitted = (permissionCodes, hasPermissions) => {
    if (!permissionCodes || permissionCodes.length === 0) return true
    return Array.isArray(hasPermissions) && permissionCodes.some(code => hasPermissions.includes(code))
}

// An item can gate on a single code (permissionRequired) or, for nav items that merge
// several formerly-standalone destinations into one page, on any of several codes
// (permissionRequiredAny) - permitted if the user holds at least one of the destination's
// tab permissions. permissionRequiredAny wins when present; otherwise this falls back to
// the original single-code check unchanged.
const isPermitted = (item, hasPermissions) => {
    if (!item) return true
    if (Array.isArray(item.permissionRequiredAny) && item.permissionRequiredAny.length > 0) {
        return isAnyPermitted(item.permissionRequiredAny, hasPermissions)
    }
    if (!item.permissionRequired) return true
    return isAnyPermitted([item.permissionRequired], hasPermissions)
}

const firstPermittedIndex = (items, hasPermissions) => {
    if (!items || items.length === 0) return 0
    const index = items.findIndex(item => isPermitted(item, hasPermissions))
    return index === -1 ? 0 : index
}

export { isPermitted, isAnyPermitted, firstPermittedIndex, NO_PERMISSION_MESSAGE }
